fragment CustomerRequirementFull on CustomerRequirement {
  name
  price
}
